(function () {
  'use strict';

  var root = document.querySelector('.ryze-clone');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LANDING_URL = '/pages/oferta';
  var CART_URL = '/cart';
  var SEARCH_URL = '/search';
  var HOME_URL = '/';

  // La cuenta atras ya no usa una fecha fija: el plazo es de 10 minutos por
  // sesion y lo publica window.RU_OFFER desde layout/theme.liquid.

  var style = document.createElement('style');
  style.textContent = [
    '.ryze-clone .rh-reveal { opacity: 0; transform: translateY(28px); transition: opacity 720ms cubic-bezier(.2,.85,.25,1), transform 720ms cubic-bezier(.2,.85,.25,1); }',
    '.ryze-clone .rh-reveal.rh-in { opacity: 1; transform: none; }',
    '.ryze-clone .strip-track { animation-play-state: running; }',
    '.ryze-clone .strip-track:hover { animation-play-state: paused; }',
    '.ryze-clone .button, .ryze-clone .outline-button, .ryze-clone .newsletter-form button, .ryze-clone .sticky-cta, .ryze-clone .menu-button, .ryze-clone .nav-actions a, .ryze-clone .hero-media, .ryze-clone .logo { cursor: pointer; }',
    '@media (prefers-reduced-motion: reduce) {',
    '  .ryze-clone .rh-reveal { opacity: 1; transform: none; transition: none; }',
    '  .ryze-clone .strip-track { animation: none; }',
    '  .ryze-clone .promobar .sb-chip--live { animation: sb-live-pulse 1.1s ease-in-out infinite !important; }',
    '}',
    '@keyframes ryzeCdPulse { 0%,100% { opacity: 1; transform: scale(1); } 50% { opacity: .55; transform: scale(.92); } }'
  ].join('\n');
  document.head.appendChild(style);

  // ===== Enlaces reales a la landing =====
  // Antes todos los CTA apuntaban a "#products", que era la seccion de
  // newsletter, y solo llegaban a la oferta gracias al router de mas abajo.
  // Ahora reescribimos los href para que funcionen tambien sin JS completo.
  var ctaSelectors = '.sticky-cta, .menu-button, .hero-media, .button, .outline-button';
  Array.prototype.forEach.call(root.querySelectorAll(ctaSelectors), function (a) {
    var href = a.getAttribute('href') || '';
    if (href === '#products' || href === '#shop' || href === '#') {
      a.setAttribute('href', LANDING_URL);
    }
  });

  // El copy de la cabecera ya no lleva fecha quemada, asi que no hay que
  // reescribirlo desde JS: vive en sections/ryze-home.liquid.

  // ===== Countdown =====
  // El plazo lo fija window.RU_OFFER (inline en layout/theme.liquid): 10 min por
  // sesion de navegador. Al llegar a 0 se queda en 00:00, la barra NO se oculta.
  var timerEl = root.querySelector('.sale-bar');
  if (timerEl) {
    var cells = timerEl.querySelectorAll('.sb-chip > span');
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

    var tick = function () {
      var p = (window.RU_OFFER && window.RU_OFFER.parts)
        ? window.RU_OFFER.parts()
        : { d: 0, h: 0, m: 0, s: 0 };
      if (cells[0]) cells[0].textContent = pad(p.d);
      if (cells[1]) cells[1].textContent = pad(p.h);
      if (cells[2]) cells[2].textContent = pad(p.m);
      if (cells[3]) cells[3].textContent = pad(p.s);
    };
    tick();
    setInterval(tick, 1000);
  }

  // ===== Click router =====
  var headerOffset = function () {
    var header = root.querySelector('.site-top');
    return header ? header.offsetHeight + 12 : 0;
  };
  var go = function (url) { window.location.href = url; };

  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;

    var a = e.target.closest('a');
    if (!a || !root.contains(a)) return;

    var href = a.getAttribute('href') || '';

    if (a.classList.contains('cart-link') || href === '#cart') {
      e.preventDefault();
      // La home no monta el header del tema, asi que el icono de carrito
      // abre aqui el carrito lateral. Sin carrito lateral, va a /cart.
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(a);
        return;
      }
      go(CART_URL);
      return;
    }

    if (href === '#search' || a.getAttribute('aria-label') === 'Search') {
      e.preventDefault();
      go(SEARCH_URL);
      return;
    }

    if (a.classList.contains('logo')) {
      e.preventDefault();
      go(HOME_URL);
      return;
    }

    if (a.closest('.footer')) return;

    // Los CTA ya llevan href real a la landing: dejamos que el navegador
    // navegue solo. Solo interceptamos si algun href quedo como ancla.
    if (href.charAt(0) === '#' && href.length > 1) {
      var target = null;
      try { target = document.querySelector(href); } catch (err) { return; }
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  });

  // ===== Scroll reveal =====
  // La barra de oferta va dentro de la cabecera sticky: si le metemos el
  // fade-in parpadea en cada carga, asi que se queda fuera del reveal.
  var revealTargets = root.querySelectorAll(
    '.benefit-strip, .callout, .section-heading, ' +
    '.review-card, .mushroom-grid article, .story-card, .faq-grid, .newsletter, .footer'
  );

  if ('IntersectionObserver' in window && !reduceMotion) {
    revealTargets.forEach(function (el) { el.classList.add('rh-reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rh-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    revealTargets.forEach(function (el) { io.observe(el); });
  }

  // ===== Marquee =====
  var track = root.querySelector('.strip-track');
  if (track && !reduceMotion) {
    track.style.animationPlayState = 'running';
  }

  // ===== Newsletter =====
  // El formulario de la home no guardaba nada (action="#" + "Thanks!" falso).
  // Lo convertimos en un alta real de cliente en Shopify.
  var newsletterForm = root.querySelector('.newsletter-form');
  if (newsletterForm && newsletterForm.getAttribute('action') === '#') {
    newsletterForm.setAttribute('action', '/contact#contact_form');
    newsletterForm.setAttribute('method', 'post');
    newsletterForm.setAttribute('accept-charset', 'UTF-8');

    var hiddenForm = document.createElement('input');
    hiddenForm.type = 'hidden';
    hiddenForm.name = 'form_type';
    hiddenForm.value = 'customer';
    newsletterForm.insertBefore(hiddenForm, newsletterForm.firstChild);

    var hiddenUtf = document.createElement('input');
    hiddenUtf.type = 'hidden';
    hiddenUtf.name = 'utf8';
    hiddenUtf.value = '\u2713';
    newsletterForm.insertBefore(hiddenUtf, newsletterForm.firstChild);

    var hiddenTags = document.createElement('input');
    hiddenTags.type = 'hidden';
    hiddenTags.name = 'contact[tags]';
    hiddenTags.value = 'newsletter';
    newsletterForm.appendChild(hiddenTags);

    var emailInput = newsletterForm.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.setAttribute('name', 'contact[email]');
      emailInput.setAttribute('required', 'required');
    }
  }

  // ===== Sticky CTA micro-elevation =====
  var stickyCta = root.querySelector('.sticky-cta');
  if (stickyCta && !reduceMotion) {
    stickyCta.style.transition = 'transform 240ms ease, box-shadow 240ms ease';
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var goingDown = y > lastY;
      stickyCta.style.transform = goingDown ? 'translateY(-4px)' : 'translateY(0)';
      lastY = y;
    }, { passive: true });
  }
})();
